import type { ZeytalCLIPureConfig } from "@zeytal/kit";
import type { FigmaPluginApi, ZeytalTokens } from "@zeytal/types";

import { roundNumber } from "@endgame/utils/roundNumber";

import { paintToSelectedFormat } from "../utils/colors.ts";
import { fontValToPx, fontValToRem } from "../utils/font.ts";
import { checkStringRegExpMatch } from "../utils/regexp.ts";

export const transformVariablesValues = (
  variables: ZeytalTokens.ProcessedVarsArray,
  userConfig: ZeytalCLIPureConfig,
) => {
  const transformedVars: ZeytalTokens.TransformedTokensArray = variables
    .map(({ name, varType, value }) => {
      let varTransformedValue = undefined;

      if (typeof value === "boolean") {
        varTransformedValue = value;
      } else if (
        varType === "COLOR" &&
        typeof value === "object" &&
        Object.hasOwn(value, "r") &&
        Object.hasOwn(value, "g") &&
        Object.hasOwn(value, "b")
      ) {
        const tempVal = { ...(value as FigmaPluginApi.RGBA) };
        tempVal.a = tempVal.a ?? 1;

        varTransformedValue = paintToSelectedFormat(
          userConfig.variables.formats.colors,
          tempVal,
        );
      } else if (typeof value === "number") {
        const { format: numberFormats } = userConfig.variables.formats.numbers;

        let valueWithUnit = "";
        numberFormats.forEach(({ mapping, unit }) => {
          if (valueWithUnit.endsWith(unit)) {
            return;
          }

          mapping.forEach((matcherStr) => {
            if (checkStringRegExpMatch(matcherStr, name)) {
              if (unit === "rem") {
                valueWithUnit = fontValToRem(value);
              } else if (unit === "px") {
                valueWithUnit = fontValToPx(value);
              }
            }
          });
        });

        varTransformedValue =
          valueWithUnit !== "" ? valueWithUnit : roundNumber(value, 5);
      } else if (typeof value === "string") {
        varTransformedValue = value;
      }

      return varTransformedValue
        ? { name, value: varTransformedValue, originType: varType }
        : undefined;
    })
    .filter((v) => !!v);

  return transformedVars;
};
